module.exports = __webpack_public_path__ + "assets/img/b0dcfe362881b169ee96f6afc91dea9d.svg";